"use client";

import Typography from "@/shared/components/common/Typography";
import { DropdownMenuSeparator } from "@/shared/components/common/drop-down";
import Link from "next/link";

import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/shared/components/common/navigation";
import Grid from "@/shared/components/common/Grid";
import Box from "@/shared/components/common/Box";
import List from "@/shared/components/common/List";
import Flex from "@/shared/components/common/Flex";

interface DesktopHeaderDropdownProps {
  title: string;
  link: string;
  navItems: { label: string; link: string; id: string }[];
}

export default function DesktopHeaderDropdown({
  title,
  link,
  navItems,
}: DesktopHeaderDropdownProps) {
  return (
    <NavigationMenu>
      <NavigationMenuList className="relative">
        <NavigationMenuItem>
          <NavigationMenuTrigger className="!gap-0 py-6 rounded-xs text-background dark:text-foreground bg-transparent dark:hover:bg-foreground/90 dark:focus:bg-muted-foreground/10 dark:data-[state=open]:bg-muted-foreground/10 text-base text-dark hover:text-primary dark:hover:text-background font-semibold">
            <Link
              href={link}
              className="border-none! text-sm text-ghost hover:text-primary font-medium"
            >
              {title}
            </Link>
          </NavigationMenuTrigger>

          <NavigationMenuContent>
            <Box className="grid w-[200px] p-2">
              <List
                items={navItems}
                renderItems={({ label, link }, index) => (
                  <NavigationMenuLink asChild>
                    <Flex direction={"col"}>
                      <Link
                        className="hover:bg-gray-100 p-2 rounded-xs"
                        href={link}
                      >
                        <Typography className="text-end">{label}</Typography>
                      </Link>

                      {navItems?.length - 1 !== index && (
                        <DropdownMenuSeparator />
                      )}
                    </Flex>
                  </NavigationMenuLink>
                )}
              />
            </Box>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
}
